<template>
  <div class="step-body step-contacts">
    <div class="optional-banner">
      <span class="optional-banner-tag">לא חובה</span>
      <span>תוסיפו את אנשי הקשר המקצועיים שלכם · נציגי תעשייה יוכלו לפנות אליהם ישירות</span>
    </div>

    <div class="contacts-list">
      <div
        v-for="ct in contactTypes"
        :key="ct.id"
        class="contact-card"
        :class="{ on: contactFor(ct.id).enabled }"
      >
        <button type="button" class="contact-card-head" @click="toggleEnabled(ct.id)">
          <span class="contact-card-icon">
            <LtIcon :name="ct.icon" :size="22" />
          </span>
          <span class="contact-card-meta">
            <span class="contact-card-title">{{ ct.label }}</span>
            <span class="contact-card-desc">{{ ct.desc }}</span>
          </span>
          <span class="contact-toggle" :class="{ on: contactFor(ct.id).enabled }">
            <span class="contact-toggle-dot"></span>
          </span>
        </button>

        <div v-if="contactFor(ct.id).enabled" class="contact-card-body">
          <LtField label="שם מלא" compact :error="errorsFor(ct.id).name">
            <div class="input-wrap">
              <LtIcon name="user" :size="16" />
              <input type="text" :value="contactFor(ct.id).name" @input="update(ct.id, { name: $event.target.value })" placeholder="שם פרטי ומשפחה" />
            </div>
          </LtField>
          <LtField label="טלפון" compact :error="errorsFor(ct.id).phone">
            <div class="input-wrap">
              <LtIcon name="phone" :size="16" />
              <input type="tel" :value="contactFor(ct.id).phone" @input="update(ct.id, { phone: $event.target.value })" placeholder="050-0000000" dir="ltr" />
            </div>
          </LtField>
          <LtField label="מייל" compact :error="errorsFor(ct.id).email">
            <div class="input-wrap">
              <LtIcon name="mail" :size="16" />
              <input type="email" :value="contactFor(ct.id).email" @input="update(ct.id, { email: $event.target.value })" placeholder="contact@example.com" dir="ltr" />
            </div>
          </LtField>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LtIcon from './LtIcon.vue';
import LtField from './LtField.vue';
import { CONTACT_TYPES } from './data.js';

export default {
  name: 'StepContacts',
  components: { LtIcon, LtField },
  props: {
    data:   { type: Object, required: true },
    errors: { type: Object, default: () => ({}) },
  },
  emits: ['update'],
  computed: {
    contactTypes() { return CONTACT_TYPES; },
    contacts()     { return this.data.contacts || {}; },
  },
  methods: {
    contactFor(id) {
      return this.contacts[id] || { enabled: false, name: '', phone: '', email: '' };
    },
    errorsFor(id) {
      return (this.errors.contacts && this.errors.contacts[id]) || {};
    },
    update(id, patch) {
      const cur = this.contactFor(id);
      const next = { ...this.contacts, [id]: { ...cur, ...patch } };
      this.$emit('update', { contacts: next });
    },
    toggleEnabled(id) {
      const c = this.contactFor(id);
      this.update(id, { enabled: !c.enabled });
    },
  },
}
</script>
